import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import { replaceColor } from "lottie-colorify";
import CheckSolid from "static/lottie/check_solid.json";

export function CheckLottie(props) {
  const { containerSize } = props;
  const containerRef = useRef(null);
  const animRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // In case of re-mounts or StrictMode double-invoke, ensure a clean slate
    try {
      if (animRef.current) {
        animRef.current.destroy();
        animRef.current = null;
      }
      container.innerHTML = "";
    } catch {}

    // Guard against environments without DOM (SSR)
    if (typeof window === "undefined") return;

    const instance = lottie.loadAnimation({
      container,
      renderer: "svg",
      loop: false,
      autoplay: true,
      animationData: replaceColor("#2C4BEC", "#0F55A7", CheckSolid),
      rendererSettings: {
        progressiveLoad: true,
        preserveAspectRatio: "xMidYMid meet",
      },
    });

    animRef.current = instance;

    return () => {
      try {
        if (animRef.current) {
          animRef.current.destroy();
          animRef.current = null;
        }
        if (container) container.innerHTML = "";
      } catch {}
    };
  }, []);

  return (
    <div>
      <div
        style={{ width: containerSize, height: containerSize }}
        ref={containerRef}
      />
    </div>
  );
}
